import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Flex from "common/Boxes/Flex.tsx";
import { ConfigurationCard } from "features/settings/common/styles.ts";
import styled, { useTheme } from "styled-components";
import Title from "common/Typography/Title.tsx";
import ArrowLeftOutlined from "@ant-design/icons/ArrowLeftOutlined";
import { useBottomNavigator } from "utils/hooks/misc.tsx";
import EmailAndPassword from "features/settings/Security/ConnectEmail/EmailAndPassword.tsx";
import VerifyEmail from "features/settings/Security/ConnectEmail/VerifyEmail.tsx";
import { SECURITY_SETTINGS_PATH } from "common/constants.ts";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import NewLookFormPanel from "features/settings/NewLook/NewLookFormPanel.tsx";

const ConnectEmailPage = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.SETTINGS);
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [emailValidatorUuid, setEmailValidatorUuid] = useState("");
  const [step, setStep] = useState(Step.EMAIL_AND_PASSWORD);
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const maxWidth = isBottomNavigator ? "100%" : "375px";
  const { isNewLook } = useTheme();
  const { t: tCommon } = useTypedTranslation(LanguageNameSpaces.COMMON);

  const stepToContent = {
    [Step.EMAIL_AND_PASSWORD]: (
      <EmailAndPassword
        nextStep={() => setStep(Step.VERIFY_EMAIL)}
        setEmail={setEmail}
        setEmailValidatorUuid={setEmailValidatorUuid}
      />
    ),
    [Step.VERIFY_EMAIL]: (
      <VerifyEmail email={email} emailValidatorUuid={emailValidatorUuid} />
    ),
  };

  const title =
    step === Step.EMAIL_AND_PASSWORD
      ? t("connect_email.title")
      : t("connect_email.verify_title");

  if (isNewLook) {
    return (
      <NewLookFormPanel
        title={title}
        onBack={() => history.replace(SECURITY_SETTINGS_PATH)}
        backLabel={tCommon("page_title.account_and_security")}
      >
        {stepToContent[step]}
      </NewLookFormPanel>
    );
  }

  return (
    <Flex
      $justifyContent="center"
      $alignItems="center"
      $flexDirection="column"
      style={{
        margin: `${isBottomNavigator ? 16 : 32}px 12px`,
      }}
    >
      <BackWrapper style={{ maxWidth, width: "100%" }}>
        <Flex $justifyContent="flex-start">
          <ArrowLeft onClick={() => history.replace(SECURITY_SETTINGS_PATH)} />
          <Title level={3} style={{ marginLeft: 12 }}>
            {step === Step.EMAIL_AND_PASSWORD
              ? t("connect_email.title")
              : t("connect_email.verify_title")}
          </Title>
        </Flex>
      </BackWrapper>
      <ConfigurationCard style={{ width: maxWidth }}>
        {stepToContent[step]}
      </ConfigurationCard>
    </Flex>
  );
};

export default ConnectEmailPage;

enum Step {
  EMAIL_AND_PASSWORD = "emailAndPassword",
  VERIFY_EMAIL = "verifyEmail",
}

const BackWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;
const ArrowLeft = styled(ArrowLeftOutlined)`
  font-size: 18px;
  cursor: pointer;
`;
